<template>
  <div>
    <v-card class="mx-auto mt-5 px-3" max-width="300" tile>
      <v-list dense>
        <v-subheader>Páginas</v-subheader>
        <v-list-item-group>
          <v-list-item to="signupaluno">
            Signup do aluno
          </v-list-item>
          <v-list-item to="admin">
            Admin
          </v-list-item>
          <v-list-item to="aulas">
            Aluno
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      showCreateFreetime: undefined
    };
  },
  computed: {
    ...mapState(["userToken"])
  },
  mounted() {
  
  },
  methods: {
    async makeRequest() {
      const response = await this.axios.get("/");
      this.subjects = response.data.map(this.parseSubject);
    },
    parseSubject({ subject }) {
      return subject;
    }
  }
};
</script>
